import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { HeroVisual } from './HeroVisual';
import { getWhatsAppUrl } from '../lib/whatsapp';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
export function Hero() {
  const handleHeroCTA = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    // Evento 1: CompleteRegistration
    if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
      window.fbq('track', 'CompleteRegistration', {
        content_name: 'CTA Hero - Solicitar evaluación estratégica',
        content_category: 'BitzenEscala High Ticket',
        value: 0,
        currency: 'CLP'
      });
      // Evento 2: AddToCart
      // window.fbq('track', 'AddToCart', {
      //  content_name: 'CTA Hero - WhatsApp BitzenEscala',
      //  content_category: 'BitzenEscala High Ticket',
      //  value: 1000000,
      //  currency: 'CLP',
      // })
    }
    // Pequeño delay para que Meta Pixel alcance a registrar los eventos
    setTimeout(() => {
      window.open(getWhatsAppUrl(), '_blank', 'noopener,noreferrer');
    }, 300);
  };
  return <section className="relative bg-navy-950 text-white overflow-hidden pt-6 pb-14 lg:pt-12 lg:pb-24" data-id="element-141">
      {/* Layered background gradients */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy-900 via-navy-950 to-black" data-id="element-142"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent/20 blur-[120px] rounded-full" data-id="element-143"></div>
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] bg-accent/10 blur-[100px] rounded-full" data-id="element-144"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="grid lg:grid-cols-2 lg:gap-8 items-center gap-8" data-id="element-146">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-147">
            <h1 className="font-heading tracking-tight sm:text-5xl lg:text-[3.25rem] lg:leading-[1.05] font-[600] text-[25px]" data-id="element-148">
              Ayudo a dueños de{' '}
              <span className="text-accent" data-id="element-149">pymes retail</span> a lanzar su{' '}
              <span className="text-accent" data-id="element-150">
                canal de ventas online en 21 días
              </span>{' '}
              y comenzar a vender desde el primer mes, sin webs estáticas ni
              soluciones improvisadas, con el sistema de ecommerce profesional
              automatizado <span className="text-accent" data-id="element-151">BitzenEscala™</span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mb-4 pt-[10px] pb-[10px]" data-id="element-152">
              <a href={getWhatsAppUrl()} target="_blank" rel="noopener noreferrer" onClick={handleHeroCTA} className="inline-flex items-center justify-center font-semibold transition-all duration-200 ease-in-out text-center cursor-pointer bg-accent hover:bg-accent-hover text-white rounded-xl px-6 py-4 text-lg shadow-lg shadow-accent/20 hover:shadow-accent/40 hover:-translate-y-0.5 w-full sm:w-auto" data-id="element-153">
                Solicitar evaluación estratégica
              </a>
            </div>

            {/* Trust Bullets */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-154">
              {['Para negocios con productos reales', 'Implementación ecommerce profesional', 'Enfoque en estructura, operación y medición', 'Sin webs estáticas ni soluciones improvisadas'].map((bullet, i) => <div key={i} className="flex items-start gap-2" data-id="element-155">
                  <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-156" />
                  <span className="text-sm text-slate-300 font-medium" data-id="element-157">
                    {bullet}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Visual Content */}
          <HeroVisual data-id="element-158" />
        </div>
      </div>
    </section>;
}